var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invite-modal-content wt-modal-grow-animation"},[_c('div',{staticClass:"invite-modal-header"},[_c('i',{staticClass:"wticon wticon-cross3",on:{"click":_vm.closeModal}})]),_vm._v(" "),_c('div',{staticClass:"invite-container"},[_c('invite-header',{attrs:{"state":_vm.currentState.header}}),_vm._v(" "),_c('div',{staticClass:"invite-body"},[_c('keep-alive',[_c(_vm.currentState.body,{tag:"component",attrs:{"handlers":{
            getUsers: _vm.getUsers,
            addUser: _vm.addUser,
            changeUser: _vm.changeUser,
            removeUser: _vm.removeUser,
            onChangeData: _vm.onChangeData,
            getOrganizations: _vm.getOrganizations,
            getProgrammers: _vm.getProgrammers,
            isMaxUsers: _vm.isMaxUsers,
            productionLine: _vm.productionLine,
          }}})],1)],1),_vm._v(" "),_c('invite-footer',{attrs:{"state":_vm.currentState.footer,"handlers":{
        changeCurrentState: _vm.changeCurrentState,
        action: _vm.action,
        isOnlyOneProgrammer: _vm.isOnlyOneProgrammer,
        isMaxUsers: _vm.isMaxUsers,
        hasUsers: _vm.hasUsers,
        hasTempUsers: _vm.hasTempUsers,
        hasProductionLine: _vm.hasProductionLine,
        currentState: _vm.currentState,
        process: _vm.process,
        processDirty: _vm.processDirty,
      }}}),_vm._v(" "),(_vm.process)?_c('div',{staticClass:"process-backdrop"}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }